import Pill from "components/Pill/PillElement";
import React from "react";

export interface InvoiceLifeCyclePillProps {
  value: server.dto.DocumentLifeCycles
  overDue?: boolean
};

const InvoiceLifeCyclePill = (props: InvoiceLifeCyclePillProps) => {
  const { value, overDue } = props;

  switch (value) {
    case "draft":
      return <Pill color="darkgray" label={RESX.DocumentLifeCycle.Draft} />;
    case "review":
      return <Pill color="purple" label={RESX.DocumentLifeCycle.Review} />;
    case "pending":
      return overDue
        ? <Pill color="pink" label={RESX.Financial.Outstanding} />
        : <Pill color="orange" label={RESX.Financial.Outstanding} />;
    case "completed":
      return <Pill color="green" label={RESX.Financial.Settled} />;
    default:
      console.error(`value ${value} is not implemented in InvoiceLifeCycleLabel`);
  }
};

export default InvoiceLifeCyclePill;